module.exports = __webpack_public_path__ + "static/images/eight.1T9hQ2g.svg";